import API from '../..';
const ENTITY = 'segments-image';

export const updateImage = (uuidSegment, image) =>
    API.put(`/api/v1/${ENTITY}/${uuidSegment}/`, { image });
